import { useSelector } from "react-redux";

import StoredLog from "../../../features/storedLogs/StoredLog";
import { displaySelector } from "../../../features/display/displaySlice";
import useOnlineStatus from "../../../common/utils/OnlineStatusProvider";
import Offline from "../../../common/pages/Offline";

import styles from "../../../styles/monitoring.module.css";


const Monitoring = () => {
    const isOnline = useOnlineStatus();

    const display = useSelector(displaySelector)
    if(isOnline){
        return (<>
            <div className={display.isDisplaySidebar ?  styles.contentPageReduce : styles.contentPageFull}>
                <div className={styles.title}>Observateur de logs</div>
                <StoredLog />
            </div>
            </>)
    }else{
        return (<Offline/>)
    }
}

export default Monitoring;